import PlaceholderImageSmall from '../../assets/placeholder-image-small.png?inline';
import { EquipmentClass } from '../../types/equipment';
import { equipmentClassLink } from '../../utils/router';
import { EquipmentListPrice } from './EquipmentListItemStyle';
import { SyntheticEvent } from 'react';

interface EquipmentListItemProps {
  equipmentClass: EquipmentClass;
}

function EquipmentListItem({ equipmentClass }: EquipmentListItemProps) {
  const onImageError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = PlaceholderImageSmall;
  };

  return (
    <div role='listitem' className='esr-equipment-webflow-list-item w-dyn-item'>
      <a className='esr-cp-item-card w-inline-block' href={equipmentClassLink(equipmentClass.slug)}>
        <div className='esr-cp-item-image-block'>
          <img
            className='esr-cp-item-image'
            src={equipmentClass.primary_image_url ?? PlaceholderImageSmall}
            alt={`image for ${equipmentClass.name}`}
            loading='lazy'
            onError={onImageError}
            data-primary-image-for={equipmentClass.equipment_class_id}
          ></img>
        </div>
        <div className='esr-cp-item-content-block'>
          <p className='esr-byline-text esr-cp-item-byline-text'>{equipmentClass.category_name}</p>
          <h2
            data-slug-value={equipmentClass.slug}
            data-equipment-name-for={equipmentClass.equipment_class_id}
            data-slug-for={equipmentClass.equipment_class_id}
            className='esr-block-title esr-equipment-class-card-title'
          >
            {equipmentClass.name}
          </h2>
        </div>
        <div className='esr-equipment-list-price'>
          <EquipmentListPrice equipmentId={equipmentClass.equipment_class_id} />
        </div>
      </a>
    </div>
  );
}

export default EquipmentListItem;
